import { CartItemOnlineFulfillmentEnum, ShopCartType } from './cart.types';

export type ProductImage = {
  type: 'image' | 'video';
  url: string;
  url_2000: string;
  url_thumb: string;
  url_x2: string;
};

export interface ProductSize {
  id: number;
  name: string;
}

interface ProductColors extends ProductSize {
  hex: string;
}

export interface ProductItem {
  id: number;
  pr_code: string;
  item_type: ShopCartType;
  name: string;
  dscr: string | null;
  brand_id: number;
  brand_name: string;
  menu_id: number;
  menu_name: string;
  category_id: number;
  category_name: string;
  price: number;
  base_price: number;
  price_range: string;
  pr_size: string;
  pr_color: string;
  pr_color_hex: string | null;
  pr_style_code: string | null;
  pr_style_id: number | null;
  style_name: string | null;
  size: string;
  allow_buying: 0 | 1;
  in_wishlist: 0 | 1;
  is_fav: 0 | 1;
  meta_title: string;
  meta_dscr: string | null;
  is_member_price?: number;
  member_price?: number;
  primary_pr_num: number | null;
  primary_img_url: string;
  primary_img_x2_url: string;
  primary_img_thumb_url: string;
  primary_img_2000_url: string;
  rating: {
    score: number;
    review_cnt: number;
  };
  slug_id: string;
  brand_slug_id: string;
  category_slug_id: string;
  avail_colors: ProductColors[];
  avail_sizes: ProductSize[];
  avail_in_store: StoreAvailability[];
  recent_purchases: RecentPurchase[];
  dscr_line_1?: string;
  in_stock_notify: 0 | 1;
  images: ProductImage[];
  online_fulfillment: CartItemOnlineFulfillmentEnum;
  qty: number;
  order_date?: string | null;
  order_time?: string | null;
  provider_id?: number | null;
  provider_name?: string | null;
  receipt_url?: string | null;
}

export interface StoreAvailability {
  store_id: number;
  short_store_name: string;
  store_name: string;
  addr_lat: string | null;
  addr_lng: string | null;
  avail_qty: number;
  distance_to_client: number;
  qty: number;
}

export interface RecentPurchase {
  sys_dt: string;
  sys_tm: string;
  pr_id: number;
  pr_name: string;
  store_name: string;
  qty: number;
  amount: number;
  checkout_id: number;
  assisted_by: string;
  receipt_url: string | null;
}

export interface ProductPageItem {
  id: number;
  item_type: string;
  name: string;
  dscr: string | null;
  ingredients: string | null;
  application: string | null;
  shipping_info: string | null;
  refund: string;
  code: string;
  brand_id: number;
  brand_name: string;
  brand_dscr: string | null;
  category_id: number;
  category_name: string;
  rating: number;
  price: number;
  base_price: number;
  pr_size: string;
  pr_color: string;
  pr_style_id: number | null;
  pr_style_code: string | null;
  pr_style_notes: string | null;
  pr_style_dscr: string | null;
  pr_style_specs: string | null;
  kvxl_meth: number;
  allow_buying: number;
  in_wishlist: number;
  is_fav: number;
  video_url: string;
  meta_title?: string;
  meta_dscr?: string | null;
  slug_id: string;
  brand_slug_id: string;
  category_slug_id: string;
  avail_colors: ProductColors[];
  avail_sizes: ProductSize[];
  images: ProductImage[];
  avail_in_store: StoreAvailability[];
  recent_purchases: RecentPurchase[];
}

export enum ProductTypeListParams {
  ShowPurchased = 'show_purchased',
  ShowFavourites = 'show_favourites',
  ShowArrivals = 'show_arrivals',
  ShowRecommended = 'show_recommended'
}

export interface GetProductTypeListParams {
  [ProductTypeListParams.ShowPurchased]?: 0 | 1;
  [ProductTypeListParams.ShowFavourites]?: 0 | 1;
  [ProductTypeListParams.ShowArrivals]?: 0 | 1;
  [ProductTypeListParams.ShowRecommended]?: 0 | 1;
}

export type ProductFilterType = 'brands' | 'categories';

export type GetProductsByFilterParams = {
  [K in ProductFilterType]?: number;
} & {
  /** OLb-api: filter by category slug id(s) */
  categories_slug?: string | string[];
  /** OLb-api: filter by brand slug id(s) */
  brands_slug?: string | string[];
  /** OLb-api: recommended products when browsing unfiltered list (omit when category/brand is selected) */
  show_recommended?: 0 | 1;
};

export type SelectedProductType = {
  id: number;
  qty: number;
  price: number;
};

export enum FilterSubType {
  FAVORITES = 'My Favorites',
  PURCHASED = 'Purchased',
  CATEGORY = 'Category',
  BRANDS = 'Brands',
  NONE = ''
}

export type FavoriteToggleResponse = {
  clid?: number;
  prid?: number;
  rel_id?: number;
  success?: boolean;
};

export type BrandType = {
  id: number;
  name: string;
  code: number;
  established_dt: string;
  country: string;
  dscr?: null | string;
  short_dscr?: null | string;
  banner_title?: null | string;
  banner_text?: null | string;
  is_featured: number;
  logo_img_url: string;
  banner_img_url: string;
  slug_id: string;
};

export type CategoryType = {
  id: number;
  name: string;
  dscr?: null | string;
  logo_img_url: string;
  domain_num: number;
  domain_name: string;
  slug_id: string;
};

export enum ProductViewType {
  GRID,
  LIST,
  SINGLE
}

export enum ProductRedirectionType {
  PRODUCT_SHOP_PAGE,
  ANY_PAGE
}
